import styled from "styled-components"

import {greys} from "@irati/ui/src/global/colors"
import media from "@irati/ui/src/global/media"

export const Container = styled.div`
  display: flex;
  align-items: center;

  ${media.tablet`
    margin-top: 10px;
  `}
`

export const Pipe = styled.div`
  background-color: ${greys.light};
  height: 45px;
  width: 2px;
  margin: 0 35px;
`

export const Bullet = styled.div`
  color: ${greys.black};
  font-size: 18px;
  margin: 0 11px 0 2px;
`
